export enum KnownCountries {
  USA = 1,
  CAN = 2,
  MEX = 3
}
